module.exports = __webpack_public_path__ + "static/hillsborough-a2367f68596dd8d8daa8e4f2686942dc.jpg";